<!-- 下拉远程搜索 + 滚动分页加载 -->
<template>
  <el-select v-model="optKey" :size="size" :multiple="multiple" :multiple-limit="multiplelimit" filterable remote
    reserve-keyword :popper-class="popperClass" :placeholder="placeholder" :remote-method="remoteMethod"
    :disabled="disabled" :loading="listLoading" @change="changeselect" @visible-change="onVisibleChange"
    :clearable="clearable">
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
    <div class="uploadTip" v-if="loadMoreLoading">数据加载中......</div>
    <div class="uploadTip" v-else-if="options.length && !hasMore">--没有更多--</div>
  </el-select>
</template>
<script>
import { remoteSelect } from "@api/User";
import { buRemoteSelect } from "@api/BurialUser";

export default {
  name: 'remote-select',
  props: {
    value: {
      type: [Number, String, Array],
      default: undefined
    },
    optName: {
      type: [Number, String, Array],
      default: undefined
    },
    tperType: {
      type: String,
      default: "User"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    size: {
      type: String,
      default: "small"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    multiplelimit: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      form: {
        pageindex: 1,
        pagesize: 10,
      },
      options: [],
      listLoading: false,
      loadMoreLoading: false,
      optKey: undefined,
      operateName: "",
      hasMore: false,
      allpage: 1,
      query_word: "",
      popperClass: `remote-select-popper-${this._uid}`,
      scrollWrap: null,
    }
  },
  mounted() {
    this.ensureSelectedOption()
  },
  beforeDestroy() {
    this.unbindScrollLoad()
  },
  watch: {
    value: {
      handler(data) {
        this.optKey = data
        this.ensureSelectedOption()
      },
      immediate: true
    },
    optName: {
      handler(data) {
        this.operateName = data ? data : ""
        this.ensureSelectedOption()
      },
      immediate: true
    }
  },
  methods: {
    ensureSelectedOption() {
      if (!this.operateName || this.optKey === undefined || this.optKey === null || this.optKey === '') {
        return
      }
      const index = this.options.findIndex(item => item.value === this.optKey)
      if (index !== -1) {
        this.$set(this.options, index, { value: this.optKey, label: this.operateName })
      } else {
        this.options.unshift({ value: this.optKey, label: this.operateName })
      }
    },
    async remoteMethod(query) {
      this.query_word = query || ""
      this.form.pageindex = 1
      await this.getList()
    },
    async onVisibleChange(visible) {
      if (visible) {
        this.form.pageindex = 1
        this.query_word = ""
        await this.getList()
        this.$nextTick(() => {
          this.bindScrollLoad()
        })
      } else {
        this.unbindScrollLoad()
      }
    },
    bindScrollLoad() {
      this.unbindScrollLoad()
      const wrap = document.querySelector(`.${this.popperClass} .el-select-dropdown__wrap`)
      if (!wrap) return
      this.scrollWrap = wrap
      this.scrollWrap.addEventListener("scroll", this.handleScroll)
    },
    unbindScrollLoad() {
      if (this.scrollWrap) {
        this.scrollWrap.removeEventListener("scroll", this.handleScroll)
        this.scrollWrap = null
      }
    },
    handleScroll() {
      if (!this.scrollWrap || this.loadMoreLoading || !this.hasMore) return
      const { scrollTop, scrollHeight, clientHeight } = this.scrollWrap
      if (scrollHeight - scrollTop - clientHeight <= 20) {
        this.loadMore()
      }
    },
    loadMore() {
      if (!this.hasMore || this.loadMoreLoading || this.form.pageindex >= this.allpage) {
        return
      }
      this.form.pageindex = this.form.pageindex + 1
      this.loadMoreLoading = true
      this.getList()
    },
    async getList() {
      const pages = {
        pagesize: this.form.pagesize,
        pageindex: this.form.pageindex,
      }
      const params = {}
      if (this.query_word !== '') {
        params.query_word = this.query_word
      }
      if (this.form.pageindex == 1) {
        this.options = []
        this.ensureSelectedOption()
        if (!this.loadMoreLoading) {
          this.listLoading = true
        }
      }
      try {
        let data = []
        if (this.tperType == "User") {
          let resdata = await remoteSelect(params, pages)
          data = resdata.data
        } else if (this.tperType == "burialUser") {
          let resdata = await buRemoteSelect(params, pages)
          data = resdata.data
        }
        const list = (data && data.data) || []
        const allcount = (data && data.allcount) || 0
        const existValues = new Set(this.options.map(i => i.value))
        const newItems = list.filter(i => !existValues.has(i.value))
        this.options = [...this.options, ...newItems]
        this.allpage = Math.ceil(allcount / this.form.pagesize) || 1
        this.hasMore = this.form.pageindex < this.allpage
      } finally {
        this.loadMoreLoading = false
        this.listLoading = false
      }
    },
    changeselect(val) {
      this.$emit('input', val)
      const index = this.options.findIndex(i => i.value === val)
      if (index !== -1) {
        this.$emit('inputAll', this.options[index])
      }
    },
  },
}
</script>
<style scoped>
.uploadTip {
  width: 100%;
  text-align: center;
  color: #bbbbbb;
}
</style>
